import { call, put, takeEvery } from 'redux-saga/effects';
import * as type from '../ActionTypes';
import { getAllTechnologyService } from '../../services/jobPost';
import { getAllTechnologiesFailure, getAllTechnologiesSuccess } from '../actions/technology';
import { getApprovedTechnologies } from '../../helper/utils';

function* getAllTechnologies(): any {
  try {
    const technology = yield call(getAllTechnologyService);
    if (technology?.data) {
      const approvedTech = yield getApprovedTechnologies(technology.data);
      yield put(getAllTechnologiesSuccess(approvedTech));
    }
  } catch (e: any) {
    yield put(getAllTechnologiesFailure(e.message));
  }
}

function* technologiesSaga() {
  yield takeEvery(type.GET_ALL_TECHNOLOGIES, getAllTechnologies);
}

export default technologiesSaga;
